import PurchaseOrderPaymentCertificateForm from "components/commission-management/payment-certificates/form";
export default PurchaseOrderPaymentCertificateForm;